import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import { compose } from 'redux';

// MATERIAL UI 
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
// import List from '@material-ui/core/List';
// import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

// COMPONENTS 
import { JDEAppBar, drawerWidth } from '../components/JDEAppBar'
import Menu from '../components/Menu/Menu';
import { Footer } from '../components/Footer';

// REDUX
import { connect } from "react-redux";
import { nodesFetchData, uiGetCountry, uiSetCountry, setRootId } from '../_actions';
import { regionsFetchData } from '../_actions/regions.actions';
import { fetchAllNodes } from '../_actions/nodesAll.actions';

const styles = theme => ({
  root: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    webkitBoxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.2)',
    mozBoxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.2)',
    boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.2)',
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    overflow: 'hidden',
    borderRight: 'none !important',
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    overflow: 'auto',
    zIndex: 5,
    [theme.breakpoints.up('md')]: {
      paddingBottom: 50,
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 110,
    },
  },
  userBar: {
    // backgroundColor: theme.palette.secondary.main,
    height: 63,
  },
  avatar: {
    margin: 10,
    backgroundColor: theme.palette.primary.main,
  },
  userName: {
    paddingTop: 22
  },
  border: {
    borderRight: '1px solid rgba(0,0,0,0.12)',
    backgroundColor: 'white',
    zIndex: 5,
  },
  pofileLink: {
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    }
  }
});

const trunc = (str,n) => {
  if(!str || str === undefined) return null;
  return (str.length > n) ? str.substr(0, n-1) + '…' : str;
}

const UserBar = ({classes, user, children}) => {
  // Verwende firstName und lastName aus user.profile
  const firstName = (user && user.profile && user.profile.firstName) ? user.profile.firstName : '';
  const lastName = (user && user.profile && user.profile.lastName) ? user.profile.lastName : '';
  const fullName = `${firstName} ${lastName}`.trim();
  
  // Initiale für Avatar
  const first = firstName ? firstName.charAt(0).toUpperCase() : '';
  const last = lastName ? lastName.charAt(0).toUpperCase() : '';
  
  return (
    <Grid container justify="flex-start" alignItems="flex-start" className={classes.userBar}>
      <Avatar className={classes.avatar}>{`${first}${last}`}</Avatar>
      <Link to="/profile"  className={classes.pofileLink}>
        <div className={classes.userName}>{trunc(fullName || (user && user.email) || '', 23)}</div>
      </Link>
    </Grid>
  )
}

class Dashboard extends Component {
  // constructor(props){
  //   super(props);
  // }

  state = {
    mobileOpen: false
  };

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  componentDidMount = async () => {
    this.props.uiGetCountry();
    const values = queryString.parse(this.props.location.search);
    let country = "";

    const countryParam = values.country || values.c;
    if(countryParam){
      const lt = {
        "de": "germany",
        "at": "austria",
        "ch": "switzerland"
      }
      country = lt[countryParam];
    }
    else
      country = localStorage.getItem("country") ? localStorage.getItem("country") : this.props.country;

    this.props.setRootId('all');
    this.props.uiSetCountry(country);

    // Primary: use stored region ID from CountrySwitcher (set when user last switched)
    const stored = localStorage.getItem('regionId');
    let regionId = stored || null;

    let regions = null;
    try {
      regions = await this.props.regionsFetchData();
    } catch (e) {
      // ignore, fetchAllNodes wird trotzdem aufgerufen
    }

    // Fallback for first-time users without a stored regionId: derive from country string
    if (!regionId && regions && regions.length > 0) {
      const flagMap = {
        germany: ['germany', 'deutschland'],
        austria: ['austria', 'österreich'],
        switzerland: ['switzerland', 'schweiz'],
      };
      const keywords = flagMap[country] || [];
      const region = regions.find(r => {
        const regionName = r.names && r.names.find(n => n.lang === 'DE');
        if (!regionName) return false;
        const name = regionName.value.toLowerCase();
        return keywords.some(k => name.includes(k));
      });
      if (region) {
        regionId = region.id;
        localStorage.setItem('regionId', String(regionId));
      }
    }

    this.props.fetchAllNodes(regionId).catch(() => {});
  }

  render(){
    const { classes, theme, children } = this.props;
    return (
      <div className={classes.root}>
        <JDEAppBar handleDrawerToggle={this.handleDrawerToggle}/>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <Menu key={this.props.country}/>
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css" className={classes.border}>
          <UserBar className={classes.userBar} {...this.props} />

          <Divider/>
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <Menu key={this.props.country}/>
          </Drawer>
        </Hidden>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {children}
        </main>
        <Footer layout="dashboard"/>
      </div>
    )
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  const { authentication } = state;
  const { user } = authentication;
  
  return {
    user,
    country: state.country,
    authentication: state.authentication,
    nodes: state.nodes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    nodesFetchData: (id) => dispatch(nodesFetchData(id)),
    uiGetCountry: () => dispatch(uiGetCountry()),
    uiSetCountry: (country) => dispatch(uiSetCountry(country)),
    setRootId: (id) => dispatch(setRootId(id)),
    regionsFetchData: () => dispatch(regionsFetchData()),
    fetchAllNodes: (regionId) => dispatch(fetchAllNodes(regionId))
  };
};

const DashboardLayout = compose(
  connect(mapStateToProps,mapDispatchToProps),
  withStyles(styles, { withTheme: true }),
  withRouter
)(Dashboard)

export default DashboardLayout;
